module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/RValueCalculator-917c2888cb770cb029ff69fd54a4b379.png";